<template>
  <div class="ui left aligned container">
    <Pagination v-model="page" :pages="totalPages" :total="totalElements" @change="go"></Pagination>
    <div class="ui divided items">
      <div class="item" v-for="item in items" :key="item.id">
        <a class="image" :href="item.pageUrl" target="_blank" :title="item.pageTitle" v-if="item.pageUrl">
          <img :src="item.pagePic.startsWith('https://static.ycyup.cn/')?item.pagePic:('/images/?url='+item.pagePic)"
               :alt="item.pageTitle">
        </a>
        <a class="image" :href="userlink(item)" target="_blank" v-else>
          <img :src="item.avatar.startsWith('https://static.ycyup.cn/')?item.avatar:('/images/?url='+item.avatar)"
               :alt="item.username">
        </a>
        <div class="content">
          <a class="header" :href="userlink(item)" target="_blank">
            <img :src="item.avatar.startsWith('https://static.ycyup.cn/')?item.avatar:('/images/?url='+item.avatar)"
                 class="ui avatar image" alt="avatar">
            {{ item.username }}
          </a>
          <div class="meta">
            <span class="datetime">{{ item.createdAt | datetime }}</span>
            <span v-if="item.source">来自{{ item.source }}</span>
            <span v-if="item.editCount"><a :href="'https://m.weibo.cn/p/231440_-_'+item.id"
                                           target="_blank">编辑记录</a></span>
          </div>
          <div class="description">
            <div class="text" v-html="item.text"></div>
            <div class="text" v-if="!item.text&&item.pageTitle">
              <a :href="item.pageUrl" target="_blank">
                {{item.pageTitle}}
              </a>
            </div>
            <div class="ui tiny images" v-viewer="options">
              <img v-for="(src,index)  in item.pics" :src="'https://static.ycyup.cn/thumbnail/' + src"
                   :data-src="'https://static.ycyup.cn/large/' + src" :key="index">
            </div>
            <video width="640" height="360" controls v-if="item.photos.length">
              <source :src="video" :key="video" type="video/mp4" v-for="video of item.photos">
            </video>
            <video width="640" height="360" controls v-if="item.videos.length">
              <source :src="video" :key="video" type="video/mp4" v-for="video of item.videos">
            </video>

            <div class="ui link fluid card" v-if="item.repostId">
              <div class="content">
                <a :href="'https://m.weibo.cn/detail/'+item.repostId" target="_blank">
                  @{{ item.repostUser }}:
                </a>
                <div v-html="item.repostText"></div>
                <a :href="'https://m.weibo.cn/detail/'+item.repostId" target="_blank">查看原文</a>
              </div>
            </div>

            <div class="ui comments" v-if="item.comments.length">
              <h3 class="ui dividing header">Comments</h3>
              <div class="comment" v-for="comment in item.comments" :key="comment.id">
                <a class="avatar" :href="userlink(item)" target="_blank">
                  <img
                      :src="item.avatar.startsWith('https://static.ycyup.cn/')?item.avatar:('/images/?url='+item.avatar)"
                      class="ui avatar image" alt="avatar">
                </a>
                <div class="content">
                  <a class="author" :href="userlink(item)" target="_blank">
                    {{ comment.username }}
                  </a>
                  <div class="metadata">
                    <span class="date">{{ comment.createdAt | datetime }}</span>
                  </div>
                  <div class="text" v-html="comment.text"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="extra">
            <a :href="link(item, '#repost')" target="_blank"><i class="reply icon"></i>
              {{ item.repostsCount }}</a>
            <a :href="link(item, '#comment')" target="_blank"><i class="comment icon"></i>
              {{ item.commentsCount }}</a>
            <a :href="link(item, '#attitude')" target="_blank"><i class="red thumbs up icon"></i>
              {{ item.attitudesCount }}</a>
            <a href="javascript:void(0);" @click="refresh(item)" v-if="user.isAdmin"><i class="refresh icon"></i></a>
            <a href="javascript:void(0);" @click="show(item)" v-if="user.authenticated"><i class="paper plane icon"></i></a>
          </div>
        </div>
      </div>
    </div>
    <Pagination v-model="page" :pages="totalPages" :total="totalElements" @change="go"></Pagination>

    <Modal v-model="modal" @submit="work" title="轮博设置">
      <form class="ui form">
        <div class="field">
          <label>微博ID</label>
          <input type="text" name="id" v-model="weibo.weiboId"/>
        </div>
        <div class="field">
          <label>点赞评论次数</label>
          <input type="number" name="likeCount" v-model="weibo.likeCount"/>
        </div>
        <div class="field">
          <label>回复微博次数</label>
          <input type="number" name="replyCount" v-model="weibo.replyCount"/>
        </div>
        <div class="field">
          <label>转发微博次数</label>
          <input type="number" name="repostCount" v-model="weibo.repostCount"/>
        </div>
      </form>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import Pagination from '@/components/Pagination'
import Modal from "@/components/Modal";
import auth from '@/services/Auth';
import EventBus from "@/services/event-bus";

export default {
  name: 'WeiboList',
  components: {
    Modal,
    Pagination
  },
  data() {
    return {
      options: {
        url: 'data-src'
      },
      mobile: false,
      totalPages: 0,
      totalElements: 0,
      page: 1,
      size: 20,
      sort: 'id,desc',
      items: [],
      user: {},
      modal: false,
      weibo: {
        weiboId: '',
        likeCount: 10,
        replyCount: 10,
        repostCount: 4
      }
    }
  },
  watch: {
    '$route'(to) {
      this.page = +to.query.page || 1
      this.load()
    }
  },
  mounted() {
    this.page = +this.$route.query.page || 1
    this.mobile = this.isMobile()
    this.user = auth.user
    EventBus.$on('login', (data) => {
      Object.assign(this.user, data)
    });
    this.load()
  },
  methods: {
    load() {
      axios.get('/weibo?page=' + (this.page - 1) + '&sort=' + this.sort).then(({data}) => {
        this.items = data.content
        this.totalPages = data.totalPages
        this.totalElements = data.totalElements
      })
    },
    go(page) {
      this.$router.push(this.$route.path + '?page=' + page)
    },
    refresh(item) {
      axios.post('/weibo/' + item.bid + '/refresh').then(({data}) => {
        Object.assign(item, data)
      })
    },
    show(item) {
      this.weibo.weiboId = item.id
      this.modal = true
    },
    work() {
      axios.post('/weibo/work', this.weibo).then()
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    userlink(item) {
      if (this.mobile) {
        return 'https://m.weibo.cn/u/' + item.userId
      }
      return 'https://weibo.com/u/' + item.userId
    },
    link(item, hash) {
      if (this.mobile) {
        return 'https://m.weibo.cn/detail/' + item.id + hash
      }
      return 'https://weibo.com/' + item.userId + '/' + item.bid + hash
    }
  }
}
</script>

<style scoped>
.ui.items > .item .content .description {
  flex: auto;
}

.ui.items > .item .extra a {
  margin-right: 12px;
}
</style>
